import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import './App.css';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
  responsive: true,
  plugins: {
    title: {
      display: false,
      text: 'Chart.js Line Chart',
    },
  },
  scales: {
    y: {
      beginAtZero: true
    }
  }
};

const months = { '01/2020':3.6, '02/2020':3.7, '03/2020':3.4, '04/2020':3.2, '05/2020':2.9, '06/2020':3.3, '07/2020':3.4, '08/2020':3.3, '09/2020':3.2, '10/2020':2.9, '11/2020':2.7, '12/2020':2.3,
  '01/2021':2.2, '02/2021':2.1, '03/2021':2.3, '04/2021':3.1, '05/2021':2.9, '06/2021':2.8, '07/2021':3.4, '08/2021':4.1, '09/2021':4.9, '10/2021':5.8, '11/2021':6.0, '12/2021':6.6,
  '01/2022':9.9, '02/2022':11.1, '03/2022':12.7, '04/2022':14.2, '05/2022':16, '06/2022':17.2, '07/2022':17.5,
  '08/2022':17.2, '09/2022':18, '10/2022':15.1, '11/2022':16.2, '12/2022':15.8, '01/2023': 17.5, '02/2023': 16.7, '03/2023': 15,
  '04/2023': 12.7, '05/2023': 11.1, '06/2023': 9.7, '07/2023': 8.8, '08/2023': 8.5, '09/2023': 6.9, '10/2023': 8.5, '11/2023': 7.3, '12/2023': 6.9,
 '01/2024': 2.3, '02/2024': 2}

const labels = Object.keys(months).map((k) => k);
export const data = {
  labels,
  datasets: [
    {
      label: 'Graf: Vývoj inflace ČR',
      data: Object.keys(months).map((k) => months[k]),
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
  ],


};

function App() {
  return <Line options={options} data={data} />;
}
export default App